import type { Registry } from '../core/registry';
import { imageMask, lut } from './filters/assetFilters';
import {
  blur,
  chromaKey,
  colorCorrection,
  colorKey,
  cropPad,
  lumaKey,
  opacity,
  pixelate,
  scroll,
  sharpen,
  vignette,
} from './filters/builtin';
import { cut, fade, fadeToColor, lumaWipe, slide, swipe } from './transitions';

export { createCompositor } from './compositor';
export { defineShaderFilter, type ShaderFilterSpec } from './filters/define';

export function registerBuiltinVideoFilters(registry: Registry): void {
  registry.registerFilter(colorCorrection);
  registry.registerFilter(chromaKey);
  registry.registerFilter(colorKey);
  registry.registerFilter(lumaKey);
  registry.registerFilter(cropPad);
  registry.registerFilter(imageMask);
  registry.registerFilter(blur);
  registry.registerFilter(sharpen);
  registry.registerFilter(scroll);
  registry.registerFilter(lut);
  registry.registerFilter(opacity);
  registry.registerFilter(vignette);
  registry.registerFilter(pixelate);
}

export function registerBuiltinTransitions(registry: Registry): void {
  registry.registerTransition(cut);
  registry.registerTransition(fade);
  registry.registerTransition(fadeToColor);
  registry.registerTransition(slide);
  registry.registerTransition(swipe);
  registry.registerTransition(lumaWipe);
}
